{
  "login": {
    "title": "Вход в платформу",
    "subtitle": "Учётная запись выдаётся администратором организации.",
    "email": "Электронная почта",
    "password": "Пароль",
    "checking": "Проверяем…",
    "submit": "Войти",
    "resetHint": "Сброс пароля — через администратора",
    "demoHint": "демо-схема · объекты можно двигать мышью",
    "noConnection": "Нет связи с сервером. Проверьте подключение и повторите попытку.",
    "tooManyAttempts": "Слишком много попыток входа. {{hint}}",
    "retryInSeconds": "Повторите через {{seconds}} с.",
    "retryInAMinute": "Повторите через минуту.",
    "badCredentials": "Неверный адрес или пароль."
  },
  "change": {
    "title": "Смените пароль",
    "subtitle": "Вы вошли с временным паролем, выданным администратором. Его знаете не только вы — задайте собственный.",
    "temporary": "Временный пароль",
    "newPassword": "Новый пароль",
    "repeat": "Новый пароль ещё раз",
    "tooShort": "Не короче {{min}} символов",
    "minLength": "не короче {{min}} символов",
    "mismatch": "Пароли не совпадают",
    "saving": "Сохраняем…",
    "submit": "Сменить пароль",
    "sessionsNote": "После смены все сессии завершатся — потребуется войти заново."
  },
  "demo": {
    "label": "Демонстрационная схема сети площадки",
    "site": "Центральный офис",
    "node": {
      "gateway": "Шлюз",
      "core": "SW-1 · ядро",
      "server": "Сервер 1С",
      "pos": "Касса-1",
      "camera": "Камера · вход"
    },
    "hint": {
      "icmp2ms": "icmp 2 мс",
      "snmp18": "snmp · 18 портов",
      "noChecks": "проверок нет",
      "tcpSilent": "tcp:5900 нет ответа",
      "icmpDown": "icmp down 4 мин"
    }
  }
}
